import { v4 as uuidv4 } from 'uuid';
import { getLocalStorage, setLocalStorage } from './general';

export function getTributeUploadSessionId() {
    const key = 'mst_upload_sessionId';
    const sessionId = getLocalStorage(key);

    if (sessionId) {
        return sessionId;
    } else {
        const newSessionId = uuidv4();
        setLocalStorage(key, newSessionId);
        return newSessionId;
    }
}
